var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.tags,"return-object":"","item-text":"value","multiple":"","chips":"","label":_vm.label ? _vm.$t('tags') : undefined},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}})
}
var staticRenderFns = []

export { render, staticRenderFns }